import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation deleteWatchlist($id: String!) {
    deleteWatchlist(id: $id)
  }
`);

type Args = VariablesOf<typeof QUERY>;

export const deleteWatchlistQueryFn = async ({ id }: Args) => {
  try {
    const response = await gqlClient.request(
      gql(`
        mutation deleteWatchlist($id: String!) {
          deleteWatchlist(id: $id)
        }
      `),
      {
        id,
      }
    );
    const { deleteWatchlist, errors } = response;
    if (errors && errors.length > 0) {
      throw new Error(errors[0].message);
    }
    return deleteWatchlist;
  } catch (error) {
    console.error(error);
  }
  return false;
};
